import Api from './Api';
import { ApiResponse } from 'apisauce';
import store from '../store/Store';
import rootReducers from '../store/Reducers';

export const elasticRequest = (elasticUrl, body?) =>
  new Promise(function (resolve, reject) {
    body = body || '';
    const reduxStore: any = store({}, rootReducers).getState();
    var apiUrl =
      reduxStore.Application.backendURL + 'ElasticSearch/ElasticSearch';
    Api.post(apiUrl, { elasticUrl, body })
      .then((response: ApiResponse<any>) => {
        resolve(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  });
